module.exports = __webpack_public_path__ + "img/bd2d3d3.png";